// The menu resolves filter option ids from api/filters at runtime. This
// verified fallback closes the short cold-load window before that deferred
// request finishes, so a fast Best Sellers click never degrades to Shop All.
// Production api/filters verified 2026-08-26: Best Sellers -> Yes = 248.
export const BEST_SELLERS_FILTER_FALLBACK_ID = "248";

export const bestSellersFilterId = (
  runtimeFilterId: string | number | null | undefined
) => String(runtimeFilterId || BEST_SELLERS_FILTER_FALLBACK_ID);
